import { render } from "./dependent-modal.vue?vue&type=template&id=8858a20c"
import script from "./dependent-modal.vue?vue&type=script&lang=js"
export * from "./dependent-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__